export default __webpack_public_path__ + "static/media/14549.accountancy-tour-committee.photo.e10242e2.jpg";